<template>
  <div class="basic_wrap">
    <div class="login_bg">
      <!-- <div class="back_left" @click="$router.back()"></div> -->
      <div class="big_tit">
        <img
          class="slogo"
          height="20px"
          src="../images/login/slogo.png"
        >
      </div>
      <div
        class="language"
        @click="$router.push('/language')"
      >
        <img :src="require('../images/shop2/lang.png')">
      </div>
    </div>
    <div class="login_logo">
      <img
        class="logo"
        src="../images/shop2/top.jpg"
      >
    </div>
    <div class="form">
      <!--     <div class="cut_login">
                <router-link class="cur" to="/login"
                    >{{$t('login.signIn')}}
                    <div class="line"></div>
                </router-link>
                <router-link to="/register"
                    >{{$t('login.signUp')}}
                    <div class="line"></div>
                </router-link>
            </div> -->
      <div class="item ">
        <span class="icon">
          <van-icon
            name="contact"
            size="25"
          />
        </span>
        <!-- <span class="area_code">
          <van-popover
            v-model="showPopover"
            trigger="click"
            placement="right"
            theme="dark"
          >
            <van-grid
              class="area-code-grid"
              clickable
              :center="false"
              :border="false"
              column-num="1"
            >
              <van-grid-item
                v-for="(item, index) in actions"
                :key="index"
                :text="item.name + '(' + item.code + ')'"
                class="area-code-item"
                @click="selectAreaCode(item.code)"
              />
            </van-grid>
            <template #reference>
              <button type="button">{{ data.acode }}</button>
            </template>
          </van-popover>
        </span> -->
        <input
          v-model.trim="data.username"
          type="text"
          class="inp"
          :placeholder="$t('login.phoneNumber')"
        >
      </div>
      <div class="item">
        <span class="icon">
          <van-icon
            name="lock"
            size="25"
          />
        </span>
        <input
          v-model.trim="data.password"
          :type="password"
          class="inp"
          :placeholder="$t('login.password')"
        >
        <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div>
      <div class="item_reset_pwd">
        <van-checkbox
          v-model="checked"
          icon-size="14px"
        >
          {{ $t('login.remember') }}
        </van-checkbox>
        <!-- <router-link class="reset_pwd" to="/forgetpwd">{{$t('login.forget')}}</router-link> -->
      </div>
      <div
        type="submit"
        class="basic_btn sbtn"
        :class="
          data.username == '' || data.password == '' ? 'no_touch' : ''
        "
        @click="submit"
      >
        {{ $t('login.login') }}
      </div>
            
      <div class="register">
        {{ $t('login.signUp') }}<router-link
          class="link"
          to="/register"
        >
          {{ $t('register.register') }}
        </router-link>
      </div>
    </div>
    
    <div
      v-if="msg_show"
      class="kefu"
      :class="show_kefu ? '' : 'kefu_hide'"
      @click="kefu_to"
    >
      <img
        class="kefu_img"
        src="../images/shop2/kefu.jpg"
      >
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Fetch from "../../utils/fetch"
import { Icon, Checkbox, Popover, Grid, GridItem } from 'vant'
Vue.use(Checkbox).use(Icon).use(Popover).use(Grid).use(GridItem);

export default {
    name: "Login",
    data() {
        return {
            lang:this.$i18n.locale||"zh_cn",
            password: "password",
            show_kefu: false,
            msg_show: true,
            checked: true,
            showPopover: false,
            actions: [],
            app:null,
            data: {
                username: "",
                password: "",
                acode: "+ 81",
            },
        };
    },
    created() {
        this.data.username = localStorage.getItem('login_username') || '';
        this.data.password = localStorage.getItem('login_password') || '';
        // localStorage.removeItem('login_password');
        this.$parent.footer("user", false);
    },
    mounted() {
        var that = this;
        document.body.addEventListener(
            "scroll",
            function() {
                if (!that.show_kefu) {
                    return;
                }
                that.show_kefu = false;
            },
            false
        );
        document.addEventListener(
            "click",
            function(ev) {
                if (ev.target.className != "kefu_img") {
                    that.show_kefu = false;
                }
            },
            false
        );
        Fetch('/index/webconfig').then((r)=>{
            this.app = r.data;
            var codes = r.data.codes;
            if (codes && codes.length > 0) {
                this.actions = codes.map(function(item) {
                    return {
                        code: ' + ' + item.pcode,
                        name: '  ' + item.lang
                    };
                });
            }
        });
    },
    methods: {
        kefu_to() {
            if (this.show_kefu) {
                // window.location.href=this.app.kefu_link;
                this.$router.push("/kefu2");
            }
            this.show_kefu = !this.show_kefu;
        },
        showPwd() {
            if (this.password == "password") {
                this.password = "text";
            } else {
                this.password = "password";
            }
        },
        selectAreaCode(code) {
            this.showPopover = false;
            this.data.acode = code;
        },
        submit() {
            if (!this.data.username) {
                this.$toast(this.$t('login.phoneEmpty'));
                return;
            }

            if (!this.data.password) {
                this.$toast(this.$t('login.passwordEmpty'));
                return;
            }

            // var regex = /^[A-Za-z0-9]{1,20}$/;
            // if (!regex.test(this.data.username)) {
            //     this.$toast(this.$t('login.phoneError'));
            //     return;
            // }
            
            if(this.checked){
                localStorage.setItem('login_username', this.data.username);
                localStorage.setItem('login_password', this.data.password);
                // localStorage.removeItem('login_password');
            }
            
            if(!this.checked){
                localStorage.removeItem('login_username');
                localStorage.removeItem('login_password');
            }

            Fetch("/index/login", {
                username: this.data.username,
                password: this.data.password
            })
                .then((res) => {
                    if(res.data.token){
                        localStorage.setItem('token', res.data.token);
                    }
                    this.$toast({
                        background: "#07c160",
                        message: this.$t('login.signInSuccess'),
                    });
                })
                .then(() => {
                    this.$router.replace({
                        path:
                            this.$router.history.current.query.redirect || "/",
                    });
                });
        },
    },
};
</script>

<style lang="less" scoped>
.login_bg {
    width: 100%;
    height: 48px;
    overflow: hidden;
    background: none;
    background-size: 100% 100%;
    position: relative;
    .language{
        position: absolute;
        top: 4px;
        right: 0;
        height: 36px;
        img{
            height: 100%;
        }
    }
}

.basic_wrap .form {
    margin: 0 auto ;
    width: 94%;
    height: 332px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
    border-radius: 13px;
    padding: 0 8%;
}

.cut_login {
    width: 207px;
    line-height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    text-align: center;
    margin: 0 auto;

    a {
        width: 50%;
        padding-bottom: 10px;
        color: #808080;
        position: relative;

        .line {
            width: 100%;
            height: 1px;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: #f2f2f2;
        }
    }

    a.cur {
        color: #ee264d;;

        .line {
            height: 2px;
            background-image: linear-gradient(to right, #ee264d, #f18a11);
        }
    }
}

.mt {
    margin-top: 20px;
}

.item {
    height: 68px;
    border-bottom: 1px solid #f0f1f3;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    padding-bottom: 4px;

    .icon {
        width: 32px;
        height: 27px;

        img {
            height: 100%;
        }
    }

    input {
        height: 20px;
        margin-left: 7px;
        flex: 1;
        margin-bottom: 3px;
    }
}

.item_reset_pwd {
    font-size: 14px;
    color: green;
    text-align: right;
    margin-top: 10px;
    line-height: 20px;
}
.van-checkbox{
    margin-top: 20px;
}
.reset_pwd{
    color: #323233;
    margin-top: -20px;
    display: block;
}

.basic_btn {
    margin: 39px auto 0 auto;
}
.big_tit{
    color: #000;
}
/deep/ .van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: #ee264d;;
    border-color: #ee264d;;
}
/deep/ .van-icon {
  
}
.login_logo {
    width: 100%;
    color: #fff;
    text-align: center;
    -webkit-animation: bot_top-data .3s;
    animation: bot_top-data .3s;
}
.login_logo img {
    -webkit-animation: logobig-data .5s;
    animation: logobig-data .5s;
    width: 100%;
    margin-bottom: 10px;
    border-radius: 10px;
}
.form{
    -webkit-animation: bot_top-data .3s;
    animation: bot_top-data .3s;
}
@-webkit-keyframes bot_top-data {
    0% {
        margin-top: 1000px;
        opacity: 0;
    }
    100% {
        margin-top: 0;
        opacity: 1;
    }
}

@keyframes bot_top-data {
    0% {
        margin-top: 1000px;
        opacity: 0;
    }
    100% {
        margin-top: 0;
        opacity: 1;
    }
}
@-webkit-keyframes logobig-data{
        0% {
            -webkit-transform: scale(.3);
            opacity: 0;
        }
        50% {
            -webkit-transform: scale(1.2);
            opacity: .5;
        }
        100% {
            -webkit-transform: scale(1);
            opacity: 1;
        }
    }
    @keyframes logobig-data{
        0% {
            -webkit-transform: scale(.3);
            opacity: 0;
        }
        50% {
            -webkit-transform: scale(1.2);
            opacity: .5;
        }
        100% {
            -webkit-transform: scale(1);
            opacity: 1;
        }
    }
    .register{
        line-height: 5%;
        text-align: center;
        margin-top: 30px;
        font-size: 12px;
    }
    .basic_wrap {
        height: 100vh;
        max-width: 750px;
        // background: url(../images/shop2/1.png) no-repeat top;
        // background-size: 100% 100%;
        // background-color: #FFF;
    }
    .big_tit {
        font-size: 16px;
        font-weight: 500;
        line-height: 25px;
        padding: 10px;
        display: block;
        position:relative;
        top: auto;
    }

    .basic_wrap {
        min-height: 100vh;
        height: auto;
        overflow-y: auto;
        padding-bottom: 32px;
        box-sizing: border-box;
        background: #eef7ff;
        color: #07152b;
    }

    .login_bg {
        height: 120px;
        overflow: visible;
        background: linear-gradient(135deg, #ffd927 0%, #ffb01f 48%, #ff8418 100%);
    }

    .big_tit {
        height: 44px;
        display: flex;
        align-items: center;
        padding: 12px 22px 0;
        box-sizing: border-box;
        line-height: 1;
    }

    .slogo {
        height: 18px;
        max-width: 150px;
        object-fit: contain;
    }

    .login_bg .language {
        top: 16px;
        right: 24px;
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        background: rgba(255, 255, 255, .9);
        box-shadow: 0 6px 14px rgba(21, 44, 78, .08);
    }

    .login_bg .language img {
        width: 22px;
        height: 22px;
        object-fit: contain;
    }

    .login_logo {
        position: relative;
        z-index: 2;
        width: auto;
        margin: -24px 16px 0;
        padding: 8px;
        border-radius: 10px;
        background: #fff;
        box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
        -webkit-animation: none;
        animation: none;
        box-sizing: border-box;
    }

    .login_logo img {
        display: block;
        width: 100%;
        height: 88px;
        margin: 0;
        border-radius: 8px;
        -webkit-animation: none;
        animation: none;
        object-fit: cover;
    }

    .basic_wrap .form {
        width: auto;
        height: auto;
        margin: 18px 16px 0;
        padding: 16px 18px 18px;
        border-radius: 10px;
        background: #fff;
        box-shadow: none;
        -webkit-animation: none;
        animation: none;
        box-sizing: border-box;
    }

    .item {
        height: 54px;
        align-items: center;
        padding: 0;
        border-bottom: 1px solid #eef0f2;
    }

    .item .icon {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #8aa9d5;
        font-size: 20px;
    }

    .item input {
        min-width: 0;
        height: 34px;
        margin: 0 0 0 8px;
        color: #172033;
        font-size: 14px;
        line-height: 34px;
    }

    .item input::placeholder {
        color: #aeb4bf;
    }

    .area_code {
        flex: 0 0 58px;
        width: 58px;
        color: #172033;
        font-size: 14px;
        font-weight: 700;
        line-height: 32px;
    }

    .area_code button {
        width: 52px;
        height: 30px;
        padding: 0;
        border: 0;
        border-radius: 8px;
        background: #f7f8fc;
        color: #172033;
        font-size: 12px;
        font-weight: 700;
        line-height: 30px;
    }

    .area-code-grid {
        width: 100%;
        height: 50vh;
        overflow-y: auto;
        font-size: 14px;
    }

    /deep/ .van-popover__content {
        overflow: hidden;
        width: 220px;
        border-radius: 10px;
        background: #fff;
    }

    /deep/ .van-grid-item__content {
        padding: 8px 10px;
        color: #172033;
        font-size: 12px;
        font-weight: 700;
        line-height: 18px;
    }

    .eye_bi {
        flex: 0 0 21px;
        margin-left: 10px;
        opacity: .7;
    }

    .item_reset_pwd {
        margin-top: 12px;
        color: #4b5563;
        font-size: 12px;
        line-height: 18px;
        text-align: left;
    }

    .van-checkbox {
        margin-top: 0;
    }

    /deep/ .van-checkbox__label {
        color: #4b5563;
        font-size: 12px;
        line-height: 18px;
    }

    /deep/ .van-checkbox__icon--checked .van-icon {
        border-color: #ff9a0b;
        background-color: #ff9a0b;
    }

    .basic_btn {
        width: 100%;
        height: 44px;
        margin: 22px 0 0;
        border-radius: 10px;
        background: linear-gradient(135deg, #ffb01f 0%, #ff8418 100%);
        box-shadow: 0 8px 18px rgba(255, 132, 24, .18);
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        line-height: 44px;
    }

    .basic_btn.no_touch {
        color: rgba(255, 255, 255, .65);
        opacity: .78;
    }

    .register {
        margin-top: 16px;
        color: #4b5563;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
    }

    .register .link {
        margin-left: 6px;
        color: #ff8418;
        font-weight: 700;
    }
</style>
